module.exports = __webpack_public_path__ + "static/b-2-7c467cb87ed6c2cf886f2b165cde657e.png";